import { RouteRecordRaw } from 'vue-router'
import UserModule from './UserModule.vue'
import UserProfile from './views/UserProfile.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/user',
    component: UserModule,
    meta: { authorize: true },
    children: [
      {
        path: '',
        name: 'UserProfile',
        component: UserProfile,
        meta: { authorize: true }
      }
    ]
  }
]

export default routes
